import { LocaleEnum } from '@amzn/fire-tv-campaign-automation-service';
import { CMSConfig } from 'src/configs/campaignMetadataConfig';
import { KatDropdown } from '@amzn/katal-react';
import { StyledDropdown } from 'src/components/general/StyledDropdown';
import { useSelection } from 'src/contexts/SelectionContext';
import { PropUtils } from 'src/utils/PropUtils';
import { useEffect } from 'react';

interface LocaleSelectorProps {}

const LocaleSelector = ({}: LocaleSelectorProps) => {
  const { locale, marketplace, setLocale } = useSelection();
  const handleLocaleChange = (event: KatDropdown.ChangeEvent) => {
    setLocale(event.detail.value as LocaleEnum);
  };
  /** When marketplace is changed locale should be updated accordingly */
  useEffect(() => {
    setLocale(CMSConfig.LOCALE[marketplace][0]);
  }, [marketplace, setLocale]);

  const localeOptions = PropUtils.createOptionsFromEnumValues(CMSConfig.LOCALE[marketplace]);
  return (
    <StyledDropdown
      onChange={handleLocaleChange}
      options={localeOptions}
      label="Select Locale"
      style={{ marginRight: '25px' }}
      value={locale}
    />
  );
};

export { LocaleSelector };
